import { BaseService } from "./BaseService";

export const EmendaFederalService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('emendas-federais/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todas emendas federais:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`emendas-federais/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca da emenda federal:', error);
            return false;
        }
    },
    async autocomplete(field, search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-federais/autocomplete/${field}${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de autocomplete:', error);
            return false;
        }
    },
    async getUnidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-federais/options/unidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de unidades:', error);
            return false;
        }
    },
    async getCidadesOptions(search = '') {
        try {
            const params = search ? `?search=${encodeURIComponent(search)}` : '';
            return await BaseService.fetchResponseFromAPIGet(`emendas-federais/options/cidades${params}`);
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de cidades:', error);
            return false;
        }
    },
    async getAnosOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-federais/options/anos');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de anos:', error);
            return false;
        }
    },
    async getGerenciasOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-federais/options/gerencias');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de gerências:', error);
            return false;
        }
    },
    async getTiposEmendaOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-federais/options/tipos-emenda');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de tipos de emenda:', error);
            return false;
        }
    },
    async getModalidadesOptions() {
        try {
            return await BaseService.fetchResponseFromAPIGet('emendas-federais/options/modalidades');
        } catch (error) {
            console.error('Ocorreu um erro ao buscar opções de modalidades:', error);
            return false;
        }
    },
}

